// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-a3ca73fc]:root{--light_text_color:#666}.footer__payments[data-v-a3ca73fc]{display:flex;flex-wrap:wrap;margin-bottom:-16px}.footer__payments .footer__payments__item[data-v-a3ca73fc]{margin-right:16px;margin-bottom:16px}.footer__payments .footer__payments__item svg[data-v-a3ca73fc]{display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
